import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import { parse as parseMoney } from "vue-currency-input";
import { getField, updateField } from "vuex-map-fields";

import { localize as veeLocalize } from "vee-validate/dist/vee-validate.full";

import banklist from "../mfobanklist.json";

Vue.use(Vuex);
function findValueByKey(obj, key) {
  // Check if the key exists in the current object
  if (key in obj) {
    return obj[key];
  }

  // Iterate through the properties of the object
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      const value = obj[prop];
      if (typeof value === "object") {
        // Recursively search within nested objects
        const nestedValue = findValueByKey(value, key);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }
  }

  // Key not found
  return undefined;
}
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: {
    page: 1,
    formSubmitLoading: false,
    generalErrors: [],
    // storage_uid: localStorage.getItem("storage_uid") || null,
    // last_interaction: localStorage.getItem("last_interaction") || new Date(),
    storage_uid: null,
    last_interaction: new Date(),
    canProceedToNextPage: false,
    risk: [],
    couponCode: "",
    connection: "conncetion",
    MFOLoaded: false,
    eves_dij_plus: 0,
    kieg_emelt_eves_dij: 0,
    kieg_kedv_dij: 0,
    gyakorisag_dij_havi: 0,
    gyakorisag_szerint_fizetendo_dij: 0,
    email_valid_code: null,
    last_email: null,
    igeny_azon_href: null,
    merchant_id: null,
    engedmenyek: {},
    cities: [],
    code: false,
    product_code: "",
    mainBuildingInsuranceChanged: false,
    sideBuildingInsuranceChanged: false,
    allGoodsPriceChanged: false,
    contractorPropertyZipChanged: false,
    contractorPropertyName: "",
    isBackButtonDisabled: false,
    marks: {},
    banks: banklist,
    generalInfo: {
      contractType: false,
      contractFor: 1,
      propertyType: "tarsashaz",
      propertyInhabitated: 1,
      propertyOutskirts: 0,
      propertyPhysicalJob: 0,
      propertyOwnRight: "sajat",
      propertyZip: "",
      propertyName: "",
      selectedPropertyName: null,
    },
    insuranceProperty: {
      floorArea: "",
      recommendedInsurancePrice: 0,
      chosenInsurancePrice: "",
      builtYear: "",
      residents: 1,
      wallType: "panel",
      roofType: "bitumen",
    },
    insuranceSideBuildings: {
      template: {
        floorArea: "",
        wallType: "tegla",
        roofType: "cserep",
      },
      list: [],
      recommendedInsurancePrice: 0,
      chosenInsurancePrice: "",
    },
    insurancePersonalGoods: {
      calculatedInsurancePrice: 0,
      acceptCalculatedInsurance: 1,
      priceType: "full",
      allGoodsPrice: 0,
      summaryInputs: {
        household: 0,
        telecom: 0,
        furniture: 0,
        clothes: 0,
        kitchen: 0,
        textile: 0,
        other: 0,
      },
      valuablesUnder200: 200000,
      sideBuildingsGoodsPrice: 0,
    },
    chooseableAccesories: {
      valuablesAbove200: false,
      valuesAbove200Minimum: 200000,
      valuesAbove200Maximum: 20000000,
      valuesAbove200Sum: 0,
      valuablesAboveInputs: {
        jewelry: 0,
        antiques: 0,
        exotic: 0,
        collection: 0,
      },
      selectableList: {
        ertektargy: {
          selected: false,
          name: "Értéktárgyak",
          insurancePrice: "Kötvény alapján",
          insuranceFee: 0,
          showable: [1, 3],
        },
        keszpenz: {
          selected: false,
          name: "Készpénz",
          insurancePrice: 200000,
          insuranceFee: 2100,
          showable: [1, 3],
        },
        kulonleges_uveg: {
          selected: false,
          name: "Különleges üveg",
          insurancePrice: 300000,
          insuranceFee: 3500,
          showable: [1],
        },
        dugulas: {
          selected: false,
          name: "Duguláselhárítás",
          insurancePrice: 50000,
          insuranceFee: 500,
          showable: [1, 2],
        },
        epites: {
          selected: false,
          name: "Építés, szerelésbiztosítás",
          insurancePrice: "Kötvény alapján",
          insuranceFee: 10000,
          showable: [1, 2],
        },
        epulet_hiba: {
          selected: false,
          name: "Lakóépületek rejtett hibáiból eredő károk",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        assistance: {
          selected: false,
          name: "Asszisztencia",
          insurancePrice: 50000,
          insuranceFee: 4000,
          customEnding: " /alkalom",
          showable: [1, 2, 3],
        },
        epulettartozek_lopas: {
          selected: false,
          name: "Épülettartozékok lopása",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        szolgaltatas_kimaradas: {
          selected: false,
          name: "Szolgáltatás - kimaradásból eredő károk",
          insurancePrice: 150000,
          insuranceFee: 700,
          showable: [1, 3],
        },
        graffiti: {
          selected: false,
          name: "Graffiti",
          insurancePrice: 50000,
          insuranceFee: 700,
          showable: [1, 2],
        },
        klima: {
          selected: false,
          name: "Klímaberendezés biztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        zarcsere: {
          selected: false,
          name:
            "Zárcsere, kulcsvesztés vagy kulcstörés miatt és kulcsok pótlása",
          insurancePrice: 50000,
          insuranceFee: 700,
          showable: [1, 2],
        },
        kerti_butor: {
          selected: false,
          name: "Kerti bútor",
          insurancePrice: 100000,
          insuranceFee: 1500,
          showable: [1],
        },
        kerti_noveny: {
          selected: false,
          name: "Kerti dísznövénybiztosítás",
          insurancePrice: 100000,
          insuranceFee: 1500,
          showable: [1],
        },
        allo_noveny: {
          selected: false,
          name: "Lábon álló növényzet biztosítása",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        sporteszkoz: {
          selected: false,
          name: "Sporteszköz és sportfelszerelés",
          insurancePrice: 300000,
          insuranceFee: 5500,
          showable: [1, 3],
        },
        kisallat: {
          selected: false,
          name: "Hobbi- és kisállatbiztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        kegyeleti: {
          selected: false,
          name: "Síremlék és Kegyeleti biztosítás",
          insurancePrice: 200000,
          insuranceFee: 3800,
          showable: [1, 2, 3],
        },
        garancia: {
          selected: false,
          name: "Kiterjesztett garancia",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        okos_eszkoz: {
          selected: false,
          name: "Okos eszközök biztosítás (beleértve okos otthon eszközök)",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        berleti_dij: {
          selected: false,
          name: "Elmaradt bérleti díj biztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        okmany: {
          selected: false,
          name: "Elveszett okmány pótlása",
          insurancePrice: 70000,
          insuranceFee: 700,
          showable: [1, 3],
        },
        baleset: {
          selected: false,
          name: "Balesetbiztosítás",
          insurancePrice: 0,
          insuranceFee: "<b>5 000 Ft vagy 10 000 Ft</b> /év",
          showable: [1, 2, 3],
        },
        munkanelkuliseg: {
          selected: false,
          name: "Munkanélküliségi biztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        utasbiztositas: {
          selected: false,
          name: "Utasbiztosítás",
          insurancePrice: 0,
          insuranceFee: "<b>4 500 Ft</b> /fő/év",
          showable: [1, 2, 3],
        },
      },
      travelInsuranced: {
        template: {
          name: null,
          bornDate: null,
        },
        list: [],
      },
      accidentInsuranceType: "standard",
      accessorySumPrice: 0,
    },
    paymentOptions: {
      type: "csoportos",
      frequency: "eves",
    },
    electronicContact: 1,
    electronicInsuring: 1,
    riskSettings: {
      // startDate: new Date().setDate(new Date().getDate() + 1),
      startDate: moment(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1,
        ),
      ).format("YYYY-MM-DD"),
      locationZip: "",
      locationCity: "",
      locationName: "",
      locationType: "",
      locationHouseNumber: "",
      locationBuilding: "",
      locationTopography: "",
    },
    contractSettings: {
      lastName: "",
      firstName: "",
      motherChildName: "",
      bornName: "",
      bornCity: "",
      bornDate: "",
      phoneNumberArea: "",
      phoneNumber: "",
      email: "",
      emailVerification: "",
      emailVerified: false,
      emailVerifyToken: "",
      merchantEmail: "",
      postAddressIsTheSame: 1,
      bankAccountNumber: "",
      bankName: "",
      bankAccountHolderName: "",
      postAddress: {
        locationZip: "",
        locationCity: "",
        locationName: "",
        selectedLocationName: null,
        locationType: "",
        locationHouseNumber: "",
        locationBuilding: "",
        locationTopography: "",
      },
    },
    insuredSettings: {
      contractedIsInsured: 1,
      lastName: "",
      firstName: "",
      motherChildName: "",
      bornName: "",
      bornCity: "",
      bornDate: "",
      phoneNumberArea: "",
      phoneNumber: "",
      email: "",
    },
    mortgageSettings: {
      propertyIsMortgaged: 0,
      creditor: "",
      creditorLocation: "",
      mortgageId: "",
      mortgagePrice: 0,
      mortgageCurrency: "HUF",
      mortgageStartDate: "",
      mortgageEndDate: "",
    },
    statementSettings: {
      privacyStatement: false,
      insuranceTerms: false,
      electronicCommunation: false,
      marketingMails: false,
      acceptTerms: false,
      validMerchant: false,
      validDatas: false,
    },
    bankCodes: {
      181: "Allianz Bank Zrt.",
      644: "Alsónémedi és Vidéke Takarékszövetkezet, Alsónémedi",
      807: "Általános Közlekedési Hitelszövetkezet",
      175: "Bank of China Zrt.",
      179: "Bank Plus Bank Zrt.",
      131: "BNP Paribas Hungária Bank Zrt.",
      183: "BNP Paribas Magyarországi Fóktelepe",
      101: "Budapest Hitel és Fejlesztési Bank Zrt.",
      107: "CIB Közép-Európai Nemzetközi Bank Zrt.",
      108: "Citibank Budapest Zrt.",
      180: "Cofidis Magyarországi Fóktelep",
      142: "Commerzbank Budapest Zrt.",
      172: "Credigen Bank Zrt.",
      136: "CaLyon Bank Magyarország Zrt.",
      185: "Calyon S.A. Magyarország Bankfóktelepe",
      135: "KDB Bank (Magyarország) Zrt.",
      163: "Deutsche Bank Zrt.",
      177: "Dresdner Bank AG Magyarországi Fóktelepe",
      116: "Erste Bank Hungary Zrt.",
      170: "Ella Első Lakáshitel Kereskedelmi Bank Zrt.",
      168: "FHB Földhitel és Jelzálog Bank Nyrt.",
      182: "FHB Kereskedelmi Bank Zrt.",
      178: "Fortis Bank SA/NV Magyarországi Fóktelepe",
      880: "Fundamenta Lakáskassza Lakástakarékpénztár Zrt.",
      619: "Füzesabony és Vidéke Takarékszövetkezet, Füzesabony",
      603: "Hajdúdorog és Vidéke Takarékszövetkezet",
      114: "Hanwha Bank Magyarország Zrt.",
      162: "HBW Express Takarékszövetkezet",
      109: "UniCredit Bank Hungary Zrt.",
      171: "UniCredit Jelzálogbank Zrt.",
      147: "IC Bank Zrt.",
      111: "Inter-Európa Bank Zrt.",
      137: "ING Bank (Magyarország) Zrt.",
      104: "Kereskedelmi és Hitelbank Zrt.",
      144: "Központi Elszámolóház és Értéktár Zrt. (KELER)",
      100: "Magyar Államkincstár",
      146: "Magyar Fejlesztési Bank Zrt.",
      167: "Magyar Cetelem Bank Zrt.",
      148: "Magyar Export-Import Bank Zrt. (Eximbank)",
      103: "Magyar Külkereskedelmi Bank Nyrt.",
      190: "Magyar Nemzeti Bank",
      115: "Magyar Takarékszövetkezeti Bank Zrt.",
      141: "Magyarországi Volksbank Zrt.",
      503: "Mecsek-Vidéke Takarékszövetkezet, Mecseknádasd",
      128: "Merkantil Bank Zrt.",
      652: "Nagykáta és Vidéke Takarékszövetkezet, Nagykáta",
      184: "Oberbank AG Magyarországi Fóktelepe",
      117: "Országos Takarékpénztár és Kereskedelmi Bank Nyrt.",
      884: "OTP Jelzálogbank Zrt.",
      881: "OTP Lakástakarékpénztár Zrt.",
      655: "Örkényi Takarékszövetkezet, Örkény",
      657: "Pilisvörösvár és Vidéke Takarékszövetkezet, Pilisvörösvár",
      160: "Porsche Bank Hungária Zrt.",
      120: "Raiffeisen Bank Zrt.",
      506: "Siklós és Vidéke Takarékszövetkezet, Siklós",
      527: "Soltvadkert és Vidéke Takarékszövetkezet, Soltvadkert",
      176: "EB und HYPO Bank Burgenland-Sopron Zrt.",
      539: "Szarvas és Vidéke Takarékszövetkezet, Szarvas",
      572: "Szegvár és Vidéke Takarékszövetkezet, Szegvár",
      808: "Széchenyi István Hitelszövetkezet",
      700: "Tiszaföldvár és Vidéke Takarékszövetkezet, Tiszaföldvár",
      803: "Tiszántúli Első Hitelszövetkezet",
      659: "Turai Takarékszövetkezet, Tura",
      121: "Westdeutsche Landesbank ( Hungária) Zrt.",
    },
  },

  getters: {
    getField,
    getAllState: (state) => {
      const doNotIncludeArray = [
        "canProceedToNextPage",
        "storage_uid",
        "mainBuildingInsuranceChanged",
        "sideBuildingInsuranceChanged",
        "eves_dij_plus",
        "gyakorisag_dij_havi",
        "gyakorisag_szerint_fizetendo_dij",
        "last_interaction",
        "generalErrors",
        "allGoodsPriceChanged",
        "marks",
        "engedmenyek",
        "email_valid_code",
        "last_email",
        "contractorPropertyZipChanged",
        "contractorPropertyName",
        "formSubmitLoading",
        "igeny_azon_href",
        "merchant_id",
        "banks",
        "cities",
        "MFOLoaded",
      ];
      const filtered = Object.keys(state)
        .filter((key) => !doNotIncludeArray.includes(key))
        .reduce((obj, key) => {
          obj[key] = state[key];
          return obj;
        }, {});

      return filtered;
    },
    getDiscountSum: (state) => {
      let total = 0;
      for (const key in state.engedmenyek) {
        if (state.engedmenyek.hasOwnProperty(key)) {
          total += state.engedmenyek[key];
        }
      }
      return total * -1;
    },
    getRisks: (state) => {
      let exceptions = [
        "P040",
        "P042",
        "P043",
        "P044",
        "P046",
        "P002",
        "P017",
        "P045",
      ];
      let accessoryFound = false;
      let accesoriosAr = [];
      for (const key in state.risks) {
        if (exceptions.includes(key)) continue;

        let risk = findValueByKey(state.risks[key], "risks");
        let price = findValueByKey(state.risks[key], "dij");

        if (key === "T001") {
          let filteredDesc = state.risks[key].desc.split(",")[0];
          accesoriosAr.push({
            item_id: key,
            item_name: filteredDesc, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        } else {
          accesoriosAr.push({
            item_id: key,
            item_name:
              key === "P200".toString() ? "Kézpénz" : state.risks[key].desc, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        }
      }
      if (state?.ertektargy_osszesen) {
        accesoriosAr.push({
          item_id: "P040-P042-P043-P044-P046-P045",
          item_name: "Értéktárgyak összesen", //ez legyen a kiegészítő fedezet neve
          affiliation: "Household NOPA",
          coupon: state.couponCode,
          discount: "Na", //Ez legyen 'Na', mert nincs egyenként
          price: state.ertektargy_osszesen, //az adott kieg fedezet ára
          item_brand: "Colonnade",
          item_category: "Household",
        });
      }
      return accesoriosAr;
    },
    getProductDetails: (state) => (idArr) => {
      let detailsArr = [];
      for (const id in idArr) {
        if (idArr[id] in state.risks) {
          detailsArr.push({
            item_id: idArr[id],
            item_name: state.risks[idArr[id]].desc,
          });
        }
      }
      return detailsArr;
    },
    getMainBuildingDetails: (state) => (riskCode) => {
      let mainBuildingArr = state.risks[riskCode]?.desc.split(",");

      if (mainBuildingArr) {
        return {
          area: mainBuildingArr[0],
          wallType: mainBuildingArr[1],
          roofType: mainBuildingArr[2],
        };
      } else {
        return {
          area: "none",
          wallType: "none",
          roofType: "none",
        };
      }
    },
    getSideBuildingsDetails: (state) => (riskCode) => {
      let sideBuildinDetalis = [];
      if (state.risks[riskCode]?.desc) {
        let sideBuildingRiskArr = state.risks[riskCode].desc
          .slice(0, -1)
          .split(";");
        for (let i = 1; i <= sideBuildingRiskArr.length; i++) {
          const sideArr = sideBuildingRiskArr[i - 1].split(",");
          sideBuildinDetalis.push({
            ["sideBuilding" + i]: {
              area: sideArr[0].split(":")[1] + "m2",
              wallType: sideArr[1].split(":")[1],
              roofType: sideArr[2].split(":")[1],
            },
          });
        }
      }

      return sideBuildinDetalis;
    },
  },

  mutations: {
    updateField,
    incrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page < 5) {
        state.page++;
      }
      window.scrollTo(0, 0);
    },
    decrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page > 1) {
        state.page--;
      }

      window.scrollTo(0, 0);
    },
    setConnection(state, value) {
      state.connection = value;
    },
    setCities(state, cities) {
      state.cities = cities;
    },
    setProductCode(state, code) {
      state.product_code = code;
    },
    setFormSubmitLoading(state, status) {
      state.formSubmitLoading = status;
    },
    addSideBuilding(state, building) {
      state.insuranceSideBuildings.list.push(building);
    },
    deleteSideBuilding(state, id) {
      state.insuranceSideBuildings.list.splice(id, 1);
    },
    updateSideBuilding(state, data) {
      const index = state.insuranceSideBuildings.list.findIndex(
        (item, index) => index === data.building,
      );
      if (index !== -1)
        state.insuranceSideBuildings.list[index][data.key] = data.value;
    },
    updateAccesory(state, data) {
      const index = state.chooseableAccesories.selectableList[data.key];
      if (index)
        state.chooseableAccesories.selectableList[data.key].selected =
          data.value;
    },

    setMFOLoadedStatus(state, status) {
      state.MFOLoaded = status;
    },

    // insured persons

    addInsuredPerson(state, building) {
      state.chooseableAccesories.travelInsuranced.list.push(building);
    },
    deleteInsuredPerson(state, id) {
      state.chooseableAccesories.travelInsuranced.list.splice(id, 1);
    },
    updateInsuredPerson(state, data) {
      const index = state.chooseableAccesories.travelInsuranced.list.findIndex(
        (item, index) => index === data.index,
      );
      if (index !== -1)
        state.chooseableAccesories.travelInsuranced.list[index][data.key] =
          data.value;
    },

    // recommended and chosen insurance prices
    setRecommendedInsurancePriceMain(state, value) {
      state.insuranceProperty.recommendedInsurancePrice = value;
    },
    setRecommendedInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.recommendedInsurancePrice = value;
    },
    setRecommendedPersonalGoodsPrice(state, value) {
      state.insurancePersonalGoods.calculatedInsurancePrice = value;
    },
    setChosenInsurancePriceMain(state, value) {
      state.insuranceProperty.chosenInsurancePrice = value;
    },
    setChosenInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.chosenInsurancePrice = value;
    },
    setChosenPersonalPriceSide(state, value) {
      state.insurancePersonalGoods.allGoodsPrice = value;
    },

    // insurance property town name
    setInsurancePropertyTownName(state, name) {
      state.generalInfo.propertyName = name;
    },
    setContractPostPropertyTownName(state, name) {
      state.contractSettings.postAddress.locationCity = name;
      state.contractorPropertyName = name;
    },

    // update main and side building insurance input state
    setMainInsuranceChangedState(state, value) {
      state.mainBuildingInsuranceChanged = value;
    },
    setSideInsuranceChangedState(state, value) {
      state.sideBuildingInsuranceChanged = value;
    },
    setAllGoodsPriceChangedState(state, value) {
      state.allGoodsPriceChanged = value;
    },
    setNavigationBackButton(state, value) {
      state.isBackButtonDisabled = value;
    },
    // page allowing
    setNextPageStatus(state, status) {
      const now = new Date();
      const ONE_HOUR = 60 * 60 * 1000;
      const date = new Date(state.last_interaction);
      if (now - date > ONE_HOUR * 2) {
        this.commit("setStorageUid", null);
      }
      state.last_interaction = now;
      localStorage.setItem("last_interaction", now);
      state.canProceedToNextPage = status;
    },

    // set yearly price
    setYearlyPrice(state, price) {
      state.chooseableAccesories.accessorySumPrice = price;
    },

    setPlusAccesoriesPrice(state, price) {
      state.eves_dij_plus = price;
    },
    setFrequencyPrice(state, price) {
      state.gyakorisag_szerint_fizetendo_dij = price;
    },
    setMonthlyPrice(state, price) {
      state.gyakorisag_dij_havi = price;
    },

    setYearlyPriceWithAccesories(state, price) {
      state.kieg_emelt_eves_dij = price;
    },

    setYearlyPriceWithDiscounts(state, price) {
      state.kieg_kedv_dij = price;
    },

    setDiscounts(state, discounts) {
      state.engedmenyek = discounts;
    },

    // set max valuables above 200
    setMaxValuablesPrice(state, price) {
      state.chooseableAccesories.valuesAbove200Maximum = price;
    },

    // set email validation code
    setEmailValidationCode(state, { code, email }) {
      state.email_valid_code = code;
      state.last_email = email;
    },

    // storage uid
    setStorageUid(state, uid) {
      if (!uid) {
        state.storage_uid = null;
        // localStorage.removeItem("storage_uid");
      } else {
        state.storage_uid = uid;
        // localStorage.setItem("storage_uid", uid);
      }
    },
    setClaimIdentifierUrl(state, url) {
      state.igeny_azon_href = url;
    },
    setClaimIdentifier(state, code) {
      state.code = code;
    },
    // update values on load
    setGeneralPropertyValues(state, { name, value }) {
      if (state.generalInfo[name] != undefined) state.generalInfo[name] = value;
    },

    setInsurancePropertyValues(state, { name, value }) {
      if (state.insuranceProperty[name] != undefined)
        state.insuranceProperty[name] = value;
    },

    setInsuranceSidePropertyValues(state, { name, value }) {
      if (state.insuranceSideBuildings[name] != undefined)
        state.insuranceSideBuildings[name] = value;
    },

    setInsurancePersonalGoods(state, { name, value }) {
      if (state.insurancePersonalGoods[name] != undefined)
        state.insurancePersonalGoods[name] = value;
    },

    setInsurancePersonalGoodsInputs(state, { name, value }) {
      if (state.insurancePersonalGoods.summaryInputs[name] != undefined)
        state.insurancePersonalGoods.summaryInputs[name] = value;
    },

    setChooseableAccesoriesSelected(state, { name, value }) {
      if (state.chooseableAccesories.selectableList[name] != undefined)
        state.chooseableAccesories.selectableList[name].selected = value;
    },

    setChooseableAccesories(state, { name, value }) {
      if (state.chooseableAccesories[name] != undefined)
        state.chooseableAccesories[name] = value;
    },

    setValuablesAboveInputs(state, { name, value }) {
      if (state.chooseableAccesories.valuablesAboveInputs[name] != undefined)
        state.chooseableAccesories.valuablesAboveInputs[name] = value;
    },

    setPaymentOptions(state, { name, value }) {
      if (state.paymentOptions[name] != undefined)
        state.paymentOptions[name] = value;
    },

    setElectronicContact(state, value) {
      state.electronicContact = value;
    },

    setElectronicInsuring(state, value) {
      state.electronicInsuring = value;
    },

    updateRiskSettings(state, { name, value }) {
      if (state.riskSettings[name] != undefined)
        state.riskSettings[name] = value;
    },

    updateContractSettings(state, { name, value }) {
      if (state.contractSettings[name] != undefined)
        state.contractSettings[name] = value;
    },

    updateContractPostSettings(state, { name, value }) {
      if (state.contractSettings.postAddress[name] != undefined)
        state.contractSettings.postAddress[name] = value;
    },

    updateInsuredSettings(state, { name, value }) {
      if (state.insuredSettings[name] != undefined)
        state.insuredSettings[name] = value;
    },

    updateMortgageSettings(state, { name, value }) {
      if (state.mortgageSettings[name] != undefined)
        state.mortgageSettings[name] = value;
    },

    updateStatements(state, { name, value }) {
      if (state.statementSettings[name] != undefined)
        state.statementSettings[name] = value;
    },

    // general errors
    setGeneralErrors(state, errors) {
      errors.forEach((error) => {
        if (!state.generalErrors.includes(error)) Vue.$toast.error(error);
      });
      state.generalErrors = errors;
    },

    setMarks(state, marks) {
      state.marks = marks;
    },

    setBanks(state, banks) {
      state.banks = banks;
    },
    setRisks(state, value) {
      state.risks = value;
    },
    setErtektargyOsszesen(state, value) {
      state.ertektargy_osszesen = value;
    },
    setCouponCode(state, value) {
      state.couponCode = value;
    },
  },
  actions: {
    getMarks(context) {
      const params = new URLSearchParams();

      params.append("marks", 1);

      axios
        .post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        )
        .then((res) => {
          const data = res.data.data;
          if (data?.marks) {
            context.commit("setMarks", data.marks);
            context.commit("setConnection", data.connection);
            context.dispatch("updateMarks", data.marks);

            if (data.marks.colonnade_version && context.state.page === 1) {
              Swal.fire({
                icon: "info",
                html: `Verzió: ${data.marks.colonnade_version}`,
                showCloseButton: true,
                showConfirmButton: false,
              });
            }
          }

          if (data?.banks) {
            context.commit("setBanks", data.banks);
          }

          if (data?.error_messages?.code) {
            veeLocalize("hu", data.error_messages);
          }
        })
        .catch((err) => {
          console.error("Nem sikerült betölteni a marks-okat.");
          console.error(err);
        });
    },
    getMFOData(context, mfo_uid) {
      context.commit("setNextPageStatus", false);

      const params = new URLSearchParams();
      params.append("mfo_uid", mfo_uid);
      //console.log(`MFO lekérés – ${mfo_uid}`)

      axios
        .get(
          `${window.eqform.baseURL}${window.eqform.mfoURL ??
            "/eqform/mfo/mnb/mfo/get/"}${mfo_uid}`,
          {
            headers: {
              Accept: "*/*",
            },
          },
        )
        .then((res) => {
          const data = res.data?.inputData;

          data.mfo_uid = mfo_uid;

          if (data) {
            context.dispatch("loadStateFromData", data);

            context.commit("setNextPageStatus", true);
          }
        })
        .catch(() => {
          console.error("MFO kommunikációs hiba.");
          //Vue.$toast.error('Kommunikációs hiba.')
        });
    },
    getStoredData(context) {
      context.commit("setNextPageStatus", false);
      const state = context.state;

      const params = new URLSearchParams();
      params.append("storage_uid", state.storage_uid);

      axios
        .post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        )
        .then((result) => {
          //console.log('előtöltés')

          if (result.data.generalErrors?.length > 0) {
            //context.commit('setStorageUid', null)
            //console.log('storage_uid törölve')
            return;
          }

          const data = result.data?.labels?.result?.dump;
          if (data) {
            //console.log(data);

            context.dispatch("loadStateFromData", data);

            context.commit("setNextPageStatus", true);
          } else {
            //context.commit('setStorageUid', null)
            console.error("előtöltés sikertelen, nincs visszakapott adat");
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    async verifyPage(context, tab_id) {
      if (tab_id === 6 && context.state.formSubmitLoading) return;
      context.commit("setNextPageStatus", false);
      const state = context.state;

      context.dispatch("updateMarks", state.marks);

      if (!document.getElementById("form")) return;

      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();

      for (let [key, val] of formData.entries()) params.append(key, val);

      if (tab_id) params.append("tab_id", tab_id);
      else params.append("tab_id", state.page);

      let buildings = "";

      if (state.code === "igenyazon" && state.igeny_azon_href)
        context.commit("setClaimIdentifier", null);

      if (state.code) params.append("kod", state.code);

      state.insuranceSideBuildings.list.forEach((building) => {
        const data = `mellekepulet_alapterulet:${building.floorArea},mellekepulet_falazat:${building.wallType},mellekepulet_tetozet:${building.roofType};`;
        buildings += data;
      });

      params.append("mellekepuletek", buildings);

      if (state.chooseableAccesories.selectableList.utasbiztositas.selected) {
        let insuredPersons = "";

        state.chooseableAccesories.travelInsuranced.list.forEach((person) => {
          let bornDate = person.bornDate;
          if (bornDate instanceof Date) {
            bornDate = bornDate.toISOString().split("T")[0];
          }

          const data = `nev:${person.name || ""},szuletesi_datum:${bornDate ||
            ""};`;
          insuredPersons += data;
        });

        params.append("utas_biztositottak", insuredPersons);
      } else {
        params.append("utas_biztositottak", "");
      }

      if (params.has("ingatlan_erteke")) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceProperty.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.insuranceProperty.chosenInsurancePrice || 0;
        }
        params.set("ingatlan_erteke", money);
      }

      if (params.has("valasztott_ar_mellekepulet")) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceSideBuildings.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.insuranceSideBuildings.chosenInsurancePrice || 0;
        }
        params.set("valasztott_ar_mellekepulet", money || 0);
      }

      if (params.has("ingosag_osszesen")) {
        let money = 0;
        try {
          money = parseMoney(
            params.get("ingosag_osszesen"),
            window.currencyInputOptions,
          );
        } catch (e) {
          money = parseInt(params.get("ingosag_osszesen")) || 0;
        }
        params.set("ingosag_osszesen", money);
      }

      if (params.has("haztartasigepek"))
        params.set(
          "haztartasigepek",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.household,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("telekommunikacios_eszkozok"))
        params.set(
          "telekommunikacios_eszkozok",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.telecom,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("butorok"))
        params.set(
          "butorok",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.furniture,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("ruha_labbeli"))
        params.set(
          "ruha_labbeli",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.clothes,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("konyhai_es_furdoszobai"))
        params.set(
          "konyhai_es_furdoszobai",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.kitchen,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("textilek"))
        params.set(
          "textilek",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.textile,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("egyeb"))
        params.set(
          "egyeb",
          parseMoney(
            state.insurancePersonalGoods.summaryInputs.other,
            window.currencyInputOptions,
          ) || 0,
        );

      if (params.has("ertektargy200eig"))
        params.set(
          "ertektargy200eig",
          state.insurancePersonalGoods.valuablesUnder200,
        );
      if (params.has("mellekepulet_ingosag"))
        params.set(
          "mellekepulet_ingosag",
          parseMoney(
            state.insurancePersonalGoods.sideBuildingsGoodsPrice,
            window.currencyInputOptions,
          ) || 0,
        );

      // 2nd page
      if (params.has("ekszerek"))
        params.set(
          "ekszerek",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.jewelry,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("antik_butorok"))
        params.set(
          "antik_butorok",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.antiques,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("szormek"))
        params.set(
          "szormek",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.exotic,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("gyujtemeny"))
        params.set(
          "gyujtemeny",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.collection,
            window.currencyInputOptions,
          ) || 0,
        );

      if (
        params.has("szerzodo_email") &&
        params.has("szerzodo_email_2") &&
        (!state.email_valid_code ||
          state.last_email != state.contractSettings.email) &&
        state.contractSettings.lastName &&
        state.contractSettings.firstName
      ) {
        const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (
          !emailRegex.test(params.get("szerzodo_email")) &&
          !emailRegex.test(params.get("szerzodo_email_2"))
        )
          return;
        if (
          state.contractSettings.email ===
          state.contractSettings.emailVerification
        )
          params.set("sendvalidemail", 1);
      }

      if (params.has("biztositas_targya")) {
        const targya = params.get("biztositas_targya");

        if (targya == "ingatlan") params.set("ingosag_osszesen", 0);
        if (targya == "ingosag") params.set("ingatlan_erteke", 0);
      }

      // setting uid param if stored
      if (state.storage_uid) params.set("storage_uid", state.storage_uid);
      if (state.merchant_id) params.set("merchant_id", state.merchant_id);

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );

        if (tab_id === 6) context.commit("setFormSubmitLoading", false);

        //console.log(result.data);

        let data = result.data;

        if (data.fieldErrors?.length <= 0 && data.generalErrors?.length <= 0) {
          context.commit("setNextPageStatus", true);
        }

        if (data.connection !== state.connection) {
          context.commit("setConnection", data.data.connection);
        }
        //if(data.generalErrors.includes('#T2 storage UID is null')) context.commit('incrementPage', 1)

        context.commit("setGeneralErrors", data.generalErrors);

        if (data.labels) {
          const labels = data.labels;
          if (labels.ajanlott_osszeg_foepulet) {
            context.commit(
              "setRecommendedInsurancePriceMain",
              labels.ajanlott_osszeg_foepulet,
            );
            if (!state.mainBuildingInsuranceChanged)
              context.commit(
                "setChosenInsurancePriceMain",
                labels.ajanlott_osszeg_foepulet,
              );
          }
          if (labels.ajanlott_osszeg_mellekepulet) {
            context.commit(
              "setRecommendedInsurancePriceSide",
              labels.ajanlott_osszeg_mellekepulet,
            );
            if (
              !state.sideBuildingInsuranceChanged &&
              labels.ajanlott_osszeg_mellekepulet !=
                state.insuranceSideBuildings.chosenInsurancePrice
            )
              context.commit(
                "setChosenInsurancePriceSide",
                labels.ajanlott_osszeg_mellekepulet,
              );
          }
          if (labels.ingosagok_ajanlott_ar) {
            context.commit(
              "setRecommendedPersonalGoodsPrice",
              labels.ingosagok_ajanlott_ar,
            );
            if (
              !state.allGoodsPriceChanged &&
              labels.ingosagok_ajanlott_ar !=
                state.insurancePersonalGoods.allGoodsPrice
            )
              context.commit(
                "setChosenPersonalPriceSide",
                labels.ingosagok_ajanlott_ar,
              );
          }

          if (labels.result) {
            const save = labels.result;
            const dbDump = labels.result.dump;

            if (save.validation_code_base64) {
              if (save.validation_code_base64)
                context.commit("setEmailValidationCode", {
                  code: save.validation_code_base64,
                  email: state.contractSettings.email,
                });
            } else {
              if (save.id) context.commit("setStorageUid", labels.result.id);
              context.commit("setYearlyPrice", dbDump.alapdijosszesen || 0);
              context.commit(
                "setPlusAccesoriesPrice",
                dbDump.eves_dij_plus || 0,
              );
              context.commit("setFrequencyPrice", dbDump.gyakorisagdij || 0);
              context.commit("setMonthlyPrice", dbDump.havidij || 0);
              context.commit(
                "setYearlyPriceWithAccesories",
                dbDump.eves_dij || 0,
              );
              context.commit(
                "setYearlyPriceWithDiscounts",
                dbDump.eves_dij_csokkentett || 0,
              );
              if (dbDump?.engedmenyek) {
                const engedmenyek = dbDump.engedmenyek;
                if (engedmenyek.csoportos)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csoportos;
                else engedmenyek.fizetesi_mod_kedvezmeny = null;

                if (engedmenyek.eves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.eves;
                else if (engedmenyek.feleves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.feleves;
                else if (engedmenyek.negyedeves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.negyedeves;
                else engedmenyek.dijfizetes_gyakorisag_kedvezmeny = null;

                context.commit("setDiscounts", engedmenyek);
              }

              if (dbDump?.igeny_azon_href) {
                if (dbDump.igeny_azon_href !== context.igeny_azon_href) {
                  context.commit("setClaimIdentifierUrl", null);
                }
                context.commit("setClaimIdentifierUrl", dbDump.igeny_azon_href);
              } else {
                context.commit("setClaimIdentifierUrl", null);
              }
              if (dbDump?.PRODUCT_CODE) {
                context.commit("setProductCode", dbDump.PRODUCT_CODE);
              }
              if (dbDump?.risks) {
                context.commit("setRisks", dbDump.risks);
              }
              if (dbDump?.ertektargy_osszesen) {
                context.commit(
                  "setErtektargyOsszesen",
                  dbDump.ertektargy_osszesen,
                );
              }
              if (dbDump?.kedvezmenykod) {
                context.commit("setCouponCode", dbDump.kedvezmenykod);
              }
            }
          }
        }

        if (data.data) {
          data = result.data.data;

          if (data.ertektargy_max)
            context.commit("setMaxValuablesPrice", data.ertektargy_max);

          if (!state.contractorPropertyZipChanged) {
            if (data.szerzodo_levelezes_telepules) {
              context.commit(
                "setContractPostPropertyTownName",
                data.szerzodo_levelezes_telepules,
              );
            }
          }

          if (data.veglegesites_uzenet) {
            context.commit("setStorageUid", null);
            const message = data.veglegesites_uzenet;
            if (message.endsWith(".html")) {
              axios
                .get(message)
                .then((res) => {
                  if (res.data) {
                    Swal.fire({
                      icon: "info",
                      html: res.data,
                      showCloseButton: true,
                      showConfirmButton: false,
                      customClass: {
                        content: "text-align-left",
                      },
                    });
                  }
                })
                .catch(() => {
                  Vue.$toast.error(
                    "Hiba történt a tartalom betöltése közben. Keressen fel minket valamelyik elérhetőségünkön.",
                  );
                });
            } else if (
              message.startsWith("http://") ||
              message.startsWith("https://")
            ) {
              window.location = message;
            } else {
              Vue.$toast.info(message);
            }
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);

        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
    },
    loadStateFromData(context, data) {
      const state = context.state;

      if (data.maganszemely)
        context.commit("setGeneralPropertyValues", {
          name: "contractType",
          value: data.maganszemely ? true : false,
        });
      if (data.mfo_uid)
        context.commit("setGeneralPropertyValues", {
          name: "contractType",
          value: true,
        });
      if (data.biztositas_targya) {
        let result = 1;
        if (data.biztositas_targya == "ingatlan") result = 2;
        if (data.biztositas_targya == "ingosag") result = 3;
        context.commit("setGeneralPropertyValues", {
          name: "contractFor",
          value: result,
        });
      }
      if (data.ingatlan_tipus)
        context.commit("setGeneralPropertyValues", {
          name: "propertyType",
          value: data.ingatlan_tipus,
        });
      if ("allando_lakott" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyInhabitated",
          value: data.allando_lakott ? 1 : 0,
        });
      if ("kulterulet" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyOutskirts",
          value: data.kulterulet ? 1 : 0,
        });
      if ("fizikai" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyPhysicalJob",
          value: data.fizikai ? 1 : 0,
        });
      if (data.tulajdonjog)
        context.commit("setGeneralPropertyValues", {
          name: "propertyOwnRight",
          value: data.tulajdonjog,
        });
      if (data.iranyitoszam)
        context.commit("setGeneralPropertyValues", {
          name: "propertyZip",
          value: data.iranyitoszam,
        });

      // insurance property
      if (data.alapterulet)
        context.commit("setInsurancePropertyValues", {
          name: "floorArea",
          value: data.alapterulet,
        });
      if (data.epites_eve)
        context.commit("setInsurancePropertyValues", {
          name: "builtYear",
          value: data.epites_eve,
        });
      if (data.lakok_szama)
        context.commit("setInsurancePropertyValues", {
          name: "residents",
          value: data.lakok_szama,
        });
      if (data.foepulet_falazat)
        context.commit("setInsurancePropertyValues", {
          name: "wallType",
          value: data.foepulet_falazat,
        });
      if (data.foepulet_teto)
        context.commit("setInsurancePropertyValues", {
          name: "roofType",
          value: data.foepulet_teto,
        });
      if (data.foepulet?.ajl_min_osszeg)
        context.commit("setInsurancePropertyValues", {
          name: "recommendedInsurancePrice",
          value: data.foepulet.ajl_min_osszeg,
        });
      if (data.ingatlan_erteke) {
        context.commit("setInsurancePropertyValues", {
          name: "chosenInsurancePrice",
          value: parseInt(data.ingatlan_erteke) || 0,
        });
        context.commit("setMainInsuranceChangedState", true);
      }

      // side buildings
      if (data.mellekepuletek) {
        const mellekepuletek = data.mellekepuletek;
        if (typeof mellekepuletek === "string") {
          const buildings = data.mellekepuletek.split(";");
          buildings.forEach((building) => {
            const inputs = building.split(",");
            if (inputs.length > 1) {
              const inserted = Object.assign(
                {},
                state.insuranceSideBuildings.template,
              );
              inputs.forEach((input) => {
                const split = input.split(":");
                if (split[0] == "mellekepulet_alapterulet")
                  inserted.floorArea = parseInt(split[1]);
                if (split[0] == "mellekepulet_falazat")
                  inserted.wallType = split[1];
                if (split[0] == "mellekepulet_tetozet")
                  inserted.roofType = split[1];
              });
              context.commit("addSideBuilding", inserted);
            }
          });
        } else if (typeof mellekepuletek === "object") {
          mellekepuletek.forEach((sidebuilding) => {
            const inserted = Object.assign(
              {},
              state.insuranceSideBuildings.template,
            );
            inserted.floorArea = sidebuilding.mellekepulet_alapterulet;
            inserted.wallType = sidebuilding.mellekepulet_falazat;
            inserted.roofType = sidebuilding.mellekepulet_teto;
            context.commit("addSideBuilding", inserted);
          });
        }
      }
      if (data.mellekepulet?.ajl_min_osszeg)
        context.commit("setInsuranceSidePropertyValues", {
          name: "recommendedInsurancePrice",
          value: data.mellekepulet.ajl_min_osszeg,
        });
      if (data.valasztott_ar_mellekepulet) {
        context.commit("setInsuranceSidePropertyValues", {
          name: "chosenInsurancePrice",
          value: parseInt(data.valasztott_ar_mellekepulet) || 0,
        });
        context.commit("setSideInsuranceChangedState", true);
      }

      // personal goods
      if ("ingosag_intezmenyi_szamitas" in data)
        context.commit("setInsurancePersonalGoods", {
          name: "acceptCalculatedInsurance",
          value: data.ingosag_intezmenyi_szamitas ? 1 : 0,
        });
      if (data.bizt_osszeg_fizetes)
        context.commit("setInsurancePersonalGoods", {
          name: "priceType",
          value: data.bizt_osszeg_fizetes,
        });
      if (data.ingosag_osszesen)
        context.commit("setInsurancePersonalGoods", {
          name: "allGoodsPrice",
          value: data.ingosag_osszesen,
        });
      if (data.haztartasigepek)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "household",
          value: parseInt(data.haztartasigepek),
        });
      if (data.telekommunikacios_eszkozok)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "telecom",
          value: parseInt(data.telekommunikacios_eszkozok),
        });
      if (data.butorok)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "furniture",
          value: parseInt(data.butorok),
        });
      if (data.ruha_labbeli)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "clothes",
          value: parseInt(data.ruha_labbeli),
        });
      if (data.konyhai_es_furdoszobai)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "kitchen",
          value: parseInt(data.konyhai_es_furdoszobai),
        });
      if (data.textilek)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "textile",
          value: parseInt(data.textilek),
        });
      if (data.egyeb)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "other",
          value: parseInt(data.egyeb),
        });

      if (
        data.haztartasigepek ||
        data.telekommunikacios_eszkozok ||
        data.butorok ||
        data.ruha_labbeli ||
        data.konyhai_es_furdoszobai ||
        data.textilek ||
        data.egyeb
      ) {
        context.commit("setInsurancePersonalGoods", {
          name: "priceType",
          value: "partial",
        });
      }

      // other insurances
      if (data.mellekepulet_ingosag)
        context.commit("setInsurancePersonalGoods", {
          name: "sideBuildingsGoodsPrice",
          value: parseInt(data.mellekepulet_ingosag),
        });

      // other chooseable accesories
      if (data.ertektargy_osszesen)
        context.commit("setValuablesAboveInputs", {
          name: "jewelry",
          value: parseInt(data.ertektargy_osszesen),
        });

      if (data.ekszerek)
        context.commit("setValuablesAboveInputs", {
          name: "jewelry",
          value: parseInt(data.ekszerek),
        });
      if (data.antik_butorok)
        context.commit("setValuablesAboveInputs", {
          name: "antiques",
          value: parseInt(data.antik_butorok),
        });
      if (data.szormek)
        context.commit("setValuablesAboveInputs", {
          name: "exotic",
          value: parseInt(data.szormek),
        });
      if (data.gyujtemeny)
        context.commit("setValuablesAboveInputs", {
          name: "collection",
          value: parseInt(data.gyujtemeny),
        });
      if (data.ertektargy)
        context.commit("setChooseableAccesoriesSelected", {
          name: "ertektargy",
          value: true,
        });
      if (data.keszpenz)
        context.commit("setChooseableAccesoriesSelected", {
          name: "keszpenz",
          value: true,
        });
      if (data.kulonleges_uveg)
        context.commit("setChooseableAccesoriesSelected", {
          name: "kulonleges_uveg",
          value: true,
        });
      if (data.dugulas)
        context.commit("setChooseableAccesoriesSelected", {
          name: "dugulas",
          value: true,
        });
      if (data.epites)
        context.commit("setChooseableAccesoriesSelected", {
          name: "epites",
          value: true,
        });
      if (data.assistance)
        context.commit("setChooseableAccesoriesSelected", {
          name: "assistance",
          value: true,
        });
      if (data.fagyasztott_etel_romlas)
        context.commit("setChooseableAccesoriesSelected", {
          name: "fagyasztott_etel_romlas",
          value: true,
        });
      if (data.szolgaltatas_kimaradas)
        context.commit("setChooseableAccesoriesSelected", {
          name: "szolgaltatas_kimaradas",
          value: true,
        });
      if (data.graffiti)
        context.commit("setChooseableAccesoriesSelected", {
          name: "graffiti",
          value: true,
        });
      if (data.zarcsere)
        context.commit("setChooseableAccesoriesSelected", {
          name: "zarcsere",
          value: true,
        });
      if (data.kerti_butor)
        context.commit("setChooseableAccesoriesSelected", {
          name: "kerti_butor",
          value: true,
        });
      if (data.kerti_noveny)
        context.commit("setChooseableAccesoriesSelected", {
          name: "kerti_noveny",
          value: true,
        });
      if (data.sporteszkoz)
        context.commit("setChooseableAccesoriesSelected", {
          name: "sporteszkoz",
          value: true,
        });
      if (data.kegyeleti)
        context.commit("setChooseableAccesoriesSelected", {
          name: "kegyeleti",
          value: true,
        });
      if (data.kegyeleti_biztositas)
        context.commit("setChooseableAccesoriesSelected", {
          name: "kegyeleti_biztositas",
          value: true,
        });
      if (data.okmany)
        context.commit("setChooseableAccesoriesSelected", {
          name: "okmany",
          value: true,
        });
      if (data.baleset)
        context.commit("setChooseableAccesoriesSelected", {
          name: "baleset",
          value: true,
        });
      if (data.utasbiztositas)
        context.commit("setChooseableAccesoriesSelected", {
          name: "utasbiztositas",
          value: true,
        });

      if (data.balesetbiztositas_tipusa)
        context.commit("setChooseableAccesories", {
          name: "accidentInsuranceType",
          value: data.balesetbiztositas_tipusa,
        });

      // insured persons
      if (data.utas_biztositottak) {
        const persons = data.utas_biztositottak.split(";");
        persons.forEach((person) => {
          const inputs = person.split(",");
          if (inputs.length > 1) {
            const inserted = Object.assign(
              {},
              state.chooseableAccesories.travelInsuranced.template,
            );
            inputs.forEach((input) => {
              const split = input.split(":");
              if (split[0] == "nev") inserted.name = split[1];
              if (split[0] == "szuletesi_datum") inserted.bornDate = split[1];
            });
            context.commit("addInsuredPerson", inserted);
          }
        });
      }

      // payment data
      if (data.dijfizetes_mod)
        context.commit("setPaymentOptions", {
          name: "type",
          value: data.dijfizetes_mod,
        });
      if (data.dijfizetes_gyakorisag)
        context.commit("setPaymentOptions", {
          name: "frequency",
          value: data.dijfizetes_gyakorisag,
        });
      if ("ekommunikacio" in data)
        context.commit("setElectronicContact", data.ekommunikacio ? 1 : 0);
      if ("ekarrendezes" in data)
        context.commit("setElectronicInsuring", data.ekarrendezes ? 1 : 0);

      // 4th page data
      if (data.kockazat_kezdete)
        context.commit("updateRiskSettings", {
          name: "startDate",
          value: new Date(data.kockazat_kezdete) || data.kockazat_kezdete,
        });
      if (data.kozterulet)
        context.commit("updateRiskSettings", {
          name: "locationName",
          value: data.kozterulet,
        });
      if (data.kozterulet_jellege)
        context.commit("updateRiskSettings", {
          name: "locationType",
          value: data.kozterulet_jellege,
        });
      if (data.hazszam)
        context.commit("updateRiskSettings", {
          name: "locationHouseNumber",
          value: data.hazszam,
        });
      if (data.kockazat_epl)
        context.commit("updateRiskSettings", {
          name: "locationBuilding",
          value: data.kockazat_epl,
        });
      if (data.kockazat_helyrajzi_szam)
        context.commit("updateRiskSettings", {
          name: "locationTopography",
          value: data.kockazat_helyrajzi_szam,
        });

      if (data.szerzodo_vezeteknev)
        context.commit("updateContractSettings", {
          name: "lastName",
          value: data.szerzodo_vezeteknev,
        });
      if (data.szerzodo_keresztnev)
        context.commit("updateContractSettings", {
          name: "firstName",
          value: data.szerzodo_keresztnev,
        });
      if (data.szerzodo_anyja_leanykori_nev)
        context.commit("updateContractSettings", {
          name: "motherChildName",
          value: data.szerzodo_anyja_leanykori_nev,
        });
      if (data.szerzodo_szuletes_nev)
        context.commit("updateContractSettings", {
          name: "bornName",
          value: data.szerzodo_szuletes_nev,
        });
      if (data.szerzodo_szuletesi_hely)
        context.commit("updateContractSettings", {
          name: "bornCity",
          value: data.szerzodo_szuletesi_hely,
        });
      if (data.szerzodo_szuletesi_datum)
        context.commit("updateContractSettings", {
          name: "bornDate",
          value: data.szerzodo_szuletesi_datum,
        });
      if (data.szerzodo_bankszamlaszam)
        context.commit("updateContractSettings", {
          name: "bankAccountNumber",
          value: data.szerzodo_bankszamlaszam,
        });
      if (data.szerzodo_bankneve)
        context.commit("updateContractSettings", {
          name: "bankName",
          value: data.szerzodo_bankneve,
        });
      if (data.szerzodo_szamlatulajdonosneve)
        context.commit("updateContractSettings", {
          name: "bankAccountHolderName",
          value: data.szerzodo_szamlatulajdonosneve,
        });
      if (data.szerzodo_email)
        context.commit("updateContractSettings", {
          name: "email",
          value: data.szerzodo_email,
        });
      if (data.szerzodo_email_2)
        context.commit("updateContractSettings", {
          name: "emailVerification",
          value: data.szerzodo_email_2,
        });
      if (data.szerzodo_telefonszam_korzet)
        context.commit("updateContractSettings", {
          name: "phoneNumberArea",
          value: data.szerzodo_telefonszam_korzet,
        });
      if (data.szerzodo_telefonszam)
        context.commit("updateContractSettings", {
          name: "phoneNumber",
          value: data.szerzodo_telefonszam,
        });

      if (data.szerzodo_levelezes_egyezik)
        context.commit("updateContractSettings", {
          name: "postAddressIsTheSame",
          value: parseInt(data.szerzodo_levelezes_egyezik),
        });

      if (data.szerzodo_levelezes_irsz)
        context.commit("updateContractPostSettings", {
          name: "locationZip",
          value: data.szerzodo_levelezes_irsz,
        });
      if (data.szerzodo_levelezes_telepules)
        context.commit("updateContractPostSettings", {
          name: "locationCity",
          value: data.szerzodo_levelezes_telepules,
        });
      if (data.szerzodo_levelezes_kozterulet)
        context.commit("updateContractPostSettings", {
          name: "locationName",
          value: data.szerzodo_levelezes_kozterulet,
        });
      if (data.szerzodo_levelezes_jelleg)
        context.commit("updateContractPostSettings", {
          name: "locationType",
          value: data.szerzodo_levelezes_jelleg,
        });
      if (data.szerzodo_levelezes_hazszam)
        context.commit("updateContractPostSettings", {
          name: "locationHouseNumber",
          value: data.szerzodo_levelezes_hazszam,
        });
      if (data.szerzodo_levelezes_epl)
        context.commit("updateContractPostSettings", {
          name: "locationBuilding",
          value: data.szerzodo_levelezes_epl,
        });

      if (data.szerzodo_biztositott)
        context.commit("updateInsuredSettings", {
          name: "contractedIsInsured",
          value: parseInt(data.szerzodo_biztositott),
        });
      if (data.biztositott_vezeteknev)
        context.commit("updateInsuredSettings", {
          name: "lastName",
          value: data.biztositott_vezeteknev,
        });
      if (data.biztositott_keresztnev)
        context.commit("updateInsuredSettings", {
          name: "firstName",
          value: data.biztositott_keresztnev,
        });
      if (data.biztositott_anyja_leanykori_nev)
        context.commit("updateInsuredSettings", {
          name: "motherChildName",
          value: data.biztositott_anyja_leanykori_nev,
        });
      if (data.biztositott_szuletes_nev)
        context.commit("updateInsuredSettings", {
          name: "bornName",
          value: data.biztositott_szuletes_nev,
        });
      if (data.biztositott_szuletesi_hely)
        context.commit("updateInsuredSettings", {
          name: "bornCity",
          value: data.biztositott_szuletesi_hely,
        });
      if (data.biztositott_szuletett)
        context.commit("updateInsuredSettings", {
          name: "bornDate",
          value: data.biztositott_szuletett,
        });
      if (data.biztositott_telefonszam_korzet)
        context.commit("updateInsuredSettings", {
          name: "phoneNumberArea",
          value: data.biztositott_telefonszam_korzet,
        });
      if (data.biztositott_telefonszam)
        context.commit("updateInsuredSettings", {
          name: "phoneNumber",
          value: data.biztositott_telefonszam,
        });
      if (data.biztositott_email)
        context.commit("updateInsuredSettings", {
          name: "email",
          value: data.biztositott_email,
        });

      if (data.ingatlan_jelzalog)
        context.commit("updateMortgageSettings", {
          name: "propertyIsMortgaged",
          value: parseInt(data.ingatlan_jelzalog),
        });
      if (data.jelzalog_hitelezo_nev)
        context.commit("updateMortgageSettings", {
          name: "creditor",
          value: data.jelzalog_hitelezo_nev,
        });
      if (data.jelzalog_hitelezo_szekhely)
        context.commit("updateMortgageSettings", {
          name: "creditorLocation",
          value: data.jelzalog_hitelezo_szekhely,
        });
      if (data.jelzalog_azonosito)
        context.commit("updateMortgageSettings", {
          name: "mortgageId",
          value: data.jelzalog_azonosito,
        });
      if (data.jelzalog_hitel_osszeg)
        context.commit("updateMortgageSettings", {
          name: "mortgagePrice",
          value: parseInt(data.jelzalog_hitel_osszeg),
        });
      if (data.jelzalog_hitel_kezdete)
        context.commit("updateMortgageSettings", {
          name: "mortgageStartDate",
          value: parseInt(data.jelzalog_hitel_kezdete),
        });
      if (data.jelzalog_hitel_lejarat)
        context.commit("updateMortgageSettings", {
          name: "mortgageEndDate",
          value: parseInt(data.jelzalog_hitel_lejarat),
        });

      // statements
      if (data.nyilatkozatok) {
        const nyilatkozatok = data.nyilatkozatok;
        if (nyilatkozatok.includes("adatvedelmi_nyilatkozat"))
          context.commit("updateStatements", {
            name: "privacyStatement",
            value: "adatvedelmi_nyilatkozat",
          });
        if (nyilatkozatok.includes("biztositasi_feltetelek"))
          context.commit("updateStatements", {
            name: "insuranceTerms",
            value: "biztositasi_feltetelek",
          });
        if (nyilatkozatok.includes("hirlevel"))
          context.commit("updateStatements", {
            name: "marketingMails",
            value: "hirlevel",
          });
      }

      setTimeout(() => {
        context.commit("setMFOLoadedStatus", true);
      }, 1000);
    },
    updateMarks(context, marks) {
      const validUrl = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i",
      );

      for (let [key, value] of Object.entries(marks)) {
        if (validUrl.test(value)) {
          axios.get(value).then((res) => {
            if (res.data) value = res.data;
          });
        }
        if (
          key == "mellek_alapterulet" ||
          key == "mellek_falazat" ||
          key == "mellek_tetozet"
        ) {
          const elements = document.querySelectorAll(`[data-tooltip="${key}"]`);
          elements.forEach((element) => {
            element.addEventListener("click", () => {
              Swal.fire({
                icon: "question",
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                  content: "text-align-left",
                },
              });
            });
          });
        } else if (key == "csillag") {
          document.getElementById("invalid_inputs").innerHTML = value;
        } else {
          const element = document.getElementById(`${key}-tooltip`);
          if (element) {
            element.addEventListener("click", () => {
              Swal.fire({
                icon: "question",
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                  content: "text-align-left",
                },
              });
            });
          }
        }
      }
    },
    async getSelectLists(context) {
      const apiUrl = `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`;
      const params = new URLSearchParams();

      params.append("kod", "listofcities");

      const cityData = await axios.post(apiUrl, params);
      const cities = cityData?.data?.data?.listofcities ?? [];

      await context.commit("setCities", cities);
    },
  },
});
